/* CGC video reviews (replaces ReelUp). Markup: sections/cgc-video-reviews.liquid.
   - Cards: the muted preview loads and plays whenever any part (>= 10%) is on screen, so the peeking next card plays too (IntersectionObserver); posters until then.
   - Tap a card: full-screen player with sound. Swipe left/right or arrows = next/previous, swipe down / Esc / Back = close.
   - Add to cart: one POST /cart/add.js line (no bundle properties: Upcart empties carts carrying `_bundle_id`),
     then the cart drawer opens (same calls as tt-rose.js). */
(function () {
  if (window.CGCVideoReviews) { window.CGCVideoReviews.init(); return; }
  var CART = window.CGC_CART || { add: '/cart/add.js', cart: '/cart', addLabel: 'Add to cart', addedLabel: 'Added ✓' };
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var saveData = navigator.connection && navigator.connection.saveData;

  /* ---------- cart ---------- */
  function openDrawer() {
    try { document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: {} })); } catch (e) {}
    if (window.CGCCart) { try { if (window.CGCCart.open() !== false) return; } catch (e) {} }   /* the cart drawer (assets/cgc-drawer.js) */
    var icon = document.querySelector('.site-header .js-drawer-open-cart, a.js-drawer-open-cart, .site-header a[href$="/cart"]');
    if (icon) { icon.click(); return; }
    location.href = CART.cart;
  }
  function addToCart(id, btn, onErr) {
    if (!id || (btn && btn.getAttribute('aria-busy') === 'true')) return;
    var label = btn ? btn.textContent : '';
    if (btn) { btn.setAttribute('aria-busy', 'true'); btn.textContent = 'Adding…'; }
    window.CGC_LAST_ADD = { items: [{ id: +id, quantity: 1 }] };
    return fetch(CART.add, { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(window.CGC_LAST_ADD) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not add to cart'); return j; }); })
      .then(function () {
        if (btn) { btn.removeAttribute('aria-busy'); btn.textContent = CART.addedLabel || 'Added ✓'; setTimeout(function () { btn.textContent = label; }, 2500); }
        if (player.open) close();
        openDrawer();
      })
      .catch(function (e) { if (btn) { btn.removeAttribute('aria-busy'); btn.textContent = label; } if (onErr) onErr(e.message); else alert(e.message); });
  }

  /* ---------- card previews ---------- */
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var v = en.target.querySelector('.cgc-vr__vid');
      if (!v) return;
      if (en.isIntersecting && en.intersectionRatio >= 0.1 && !player.open) {
        if (!v.src) v.src = v.dataset.src;
        var p = v.play(); if (p && p.catch) p.catch(function () {});
        v.onplaying = function () { v.classList.add('is-on'); };
      } else if (!v.paused) { v.pause(); }
    });
  }, { threshold: [0, 0.1, 0.5] }) : null;
  function pauseAllPreviews() { document.querySelectorAll('.cgc-vr__vid').forEach(function (v) { if (!v.paused) v.pause(); }); }

  /* ---------- player ---------- */
  var player = { open: false, list: null, i: 0, el: null, ret: null, pushed: false };
  var ICON = {
    close: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M6 6l12 12M18 6L6 18"/></svg>',
    prev: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M15 5l-7 7 7 7"/></svg>',
    next: '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.2"><path d="M9 5l7 7-7 7"/></svg>',
    on: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 9h4l5-4v14l-5-4H4z"/><path d="M16 9a4 4 0 0 1 0 6M18.5 6.5a8 8 0 0 1 0 11"/></svg>',
    off: '<svg viewBox="0 0 24 24" width="20" height="20" fill="none" stroke="currentColor" stroke-width="2"><path d="M4 9h4l5-4v14l-5-4H4z"/><path d="M17 9l5 6M22 9l-5 6"/></svg>',
    play: '<svg viewBox="0 0 24 24" width="28" height="28"><path d="M8 5.5v13l10.5-6.5z" fill="currentColor"/></svg>'
  };
  function build() {
    if (player.el) return player.el;
    var d = document.createElement('div');
    d.className = 'cgc cgc-vp'; d.hidden = true;
    d.setAttribute('role', 'dialog'); d.setAttribute('aria-modal', 'true'); d.setAttribute('aria-label', 'Customer videos');
    d.innerHTML = '<div class="cgc-vp__stage">' +
      '<video class="cgc-vp__video" playsinline preload="auto"></video>' +
      '<div class="cgc-vp__tap" aria-hidden="true"></div><div class="cgc-vp__paused" hidden>' + ICON.play + '</div>' +
      '<button class="cgc-vp__btn cgc-vp__mute" type="button" aria-label="Mute">' + ICON.on + '</button>' +
      '<div class="cgc-vp__count" aria-live="polite"></div>' +
      '<button class="cgc-vp__btn cgc-vp__close" type="button" aria-label="Close video">' + ICON.close + '</button>' +
      '<div class="cgc-vp__prod" hidden></div></div>' +
      '<button class="cgc-vp__btn cgc-vp__prev" type="button" aria-label="Previous video">' + ICON.prev + '</button>' +
      '<button class="cgc-vp__btn cgc-vp__next" type="button" aria-label="Next video">' + ICON.next + '</button>';
    document.body.appendChild(d);
    var q = function (s) { return d.querySelector(s); };
    player.v = q('.cgc-vp__video');
    q('.cgc-vp__close').onclick = function () { close(); };
    q('.cgc-vp__prev').onclick = function () { go(-1); };
    q('.cgc-vp__next').onclick = function () { go(1); };
    q('.cgc-vp__mute').onclick = function () { setMuted(!player.v.muted); };
    q('.cgc-vp__tap').onclick = function () { if (player.v.paused) player.v.play().catch(function () {}); else player.v.pause(); };
    player.v.onplay = function () { q('.cgc-vp__paused').hidden = true; };
    player.v.onpause = function () { if (player.open) q('.cgc-vp__paused').hidden = false; };
    player.v.onended = function () { if (player.i < player.list.length - 1) go(1); else { player.v.currentTime = 0; player.v.play().catch(function () {}); } };
    d.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { e.preventDefault(); close(); }
      else if (e.key === 'ArrowRight') { if (e.target.tagName !== 'SELECT') go(1); }
      else if (e.key === 'ArrowLeft') { if (e.target.tagName !== 'SELECT') go(-1); }
      else if (e.key === 'Tab') { /* keep focus inside the dialog */
        var f = Array.prototype.filter.call(d.querySelectorAll('button,select,a[href]'), function (x) { return !x.disabled && x.offsetParent !== null; });
        if (!f.length) return;
        if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
        else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
      }
    });
    /* swipe: horizontal = next/previous, down = close */
    var x0 = null, y0 = null;
    d.addEventListener('touchstart', function (e) { if (e.target.closest('.cgc-vp__prod')) return; x0 = e.touches[0].clientX; y0 = e.touches[0].clientY; }, { passive: true });
    d.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0, dy = e.changedTouches[0].clientY - y0; x0 = null;
      if (Math.abs(dx) > 50 && Math.abs(dx) > Math.abs(dy)) go(dx < 0 ? 1 : -1);
      else if (dy > 90 && Math.abs(dy) > Math.abs(dx)) close();
    }, { passive: true });
    player.el = d;
    return d;
  }
  function setMuted(m) {
    player.v.muted = m;
    var b = player.el.querySelector('.cgc-vp__mute');
    b.innerHTML = m ? ICON.off : ICON.on; b.setAttribute('aria-label', m ? 'Unmute' : 'Mute');
  }
  function renderProd(it) {
    var box = player.el.querySelector('.cgc-vp__prod'), p = it.product;
    if (!p) { box.hidden = true; box.innerHTML = ''; return; }
    var cur = p.variants.filter(function (v) { return v.id === p.sel; })[0] || p.variants.filter(function (v) { return v.available; })[0] || p.variants[0];
    var opts = p.single ? '' : '<select class="cgc-vp__sel" aria-label="Option">' + p.variants.map(function (v) {
      return '<option value="' + v.id + '"' + (v.id === cur.id ? ' selected' : '') + (v.available ? '' : ' disabled') + '>' + esc(v.title) + (v.available ? '' : ' (sold out)') + '</option>';
    }).join('') + '</select>';
    box.innerHTML = (p.image ? '<img src="' + p.image + '" alt="">' : '<span></span>') +
      '<a class="cgc-vp__pname" href="' + p.url + '">' + esc(p.title) + '</a>' +
      (p.personalize ? '<a class="cgc-vp__add cgc-vp__add--pz" href="' + p.url + '">' + esc(p.personalize) + '</a>' : '<button class="cgc-vp__add" type="button"></button>') +
      '<span class="cgc-vp__pprice"></span>' + opts + '<div class="cgc-vp__err" hidden></div>';
    var add = box.querySelector('.cgc-vp__add'), sel = box.querySelector('.cgc-vp__sel'), err = box.querySelector('.cgc-vp__err');
    if (p.personalize) {   /* needs engraving / photos / a video: the link opens the product page; the option picker only shows the price */
      var pz = function () { var id = sel ? +sel.value : cur.id, v = p.variants.filter(function (x) { return x.id === id; })[0] || cur; box.querySelector('.cgc-vp__pprice').innerHTML = v.price; };
      if (sel) sel.onchange = pz;
      pz(); box.hidden = false; return;
    }
    function sync() {
      var id = sel ? +sel.value : cur.id, v = p.variants.filter(function (x) { return x.id === id; })[0] || cur;
      box.querySelector('.cgc-vp__pprice').innerHTML = v.price;
      add.disabled = !v.available; add.textContent = v.available ? (CART.addLabel || 'Add to cart') : 'Sold out';
      add.dataset.id = v.id;
    }
    if (sel) sel.onchange = sync;
    add.onclick = function () { err.hidden = true; addToCart(add.dataset.id, add, function (m) { err.textContent = m; err.hidden = false; }); };
    sync(); box.hidden = false;
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function show(i) {
    var L = player.list; player.i = Math.max(0, Math.min(L.length - 1, i));
    var it = L[player.i], v = player.v;
    v.poster = it.poster || ''; v.src = it.src; v.setAttribute('aria-label', it.label || 'Customer video');
    var p = v.play();
    if (p && p.catch) p.catch(function () { setMuted(true); v.play().catch(function () {}); });
    player.el.querySelector('.cgc-vp__count').textContent = (player.i + 1) + ' / ' + L.length;
    player.el.querySelector('.cgc-vp__prev').disabled = player.i === 0;
    player.el.querySelector('.cgc-vp__next').disabled = player.i === L.length - 1;
    renderProd(it);
  }
  function go(d) { var n = player.i + d; if (n >= 0 && n < player.list.length) show(n); }
  function open(list, i, from) {
    build(); pauseAllPreviews();
    player.list = list; player.ret = from; player.open = true;
    player.el.hidden = false; document.documentElement.classList.add('cgc-vp-open');
    setMuted(false); show(i);
    try { history.pushState({ cgcVp: 1 }, ''); player.pushed = true; } catch (e) { player.pushed = false; }
    player.el.querySelector('.cgc-vp__close').focus({ preventScroll: true });
  }
  function close(fromPop) {
    if (!player.open) return;
    player.open = false; player.v.pause(); player.v.removeAttribute('src'); player.v.load();
    player.el.hidden = true; document.documentElement.classList.remove('cgc-vp-open');
    if (player.pushed && !fromPop) { player.pushed = false; try { history.back(); } catch (e) {} }
    player.pushed = false;
    if (player.ret) try { player.ret.focus({ preventScroll: true }); } catch (e) {}
    /* restart the previews that are on screen */
    if (io) document.querySelectorAll('.cgc-vr__card').forEach(function (c) { io.unobserve(c); io.observe(c); });
  }
  window.addEventListener('popstate', function () { if (player.open) close(true); });

  /* ---------- sections ---------- */
  function initSection(sec) {
    if (sec._cgc) return; sec._cgc = true;
    var data = [];
    try { data = JSON.parse(sec.querySelector('[data-cgc-vr-data]').textContent).filter(function (x) { return x.src; }); } catch (e) {}
    var cards = sec.querySelectorAll('.cgc-vr__card');
    sec.querySelectorAll('.cgc-vr__media').forEach(function (b, i) {
      b.addEventListener('click', function () { open(data, i, b); });
    });
    sec.querySelectorAll('[data-add]').forEach(function (b) { b.addEventListener('click', function () { addToCart(b.dataset.add, b); }); });
    if (io && sec.dataset.autoplay === 'true' && !reduce && !saveData) cards.forEach(function (c) { io.observe(c); });
    /* desktop arrows */
    var list = sec.querySelector('.cgc-vr__list'), arrows = sec.querySelectorAll('.cgc-vr__arrow');
    function upd() {
      arrows[0].disabled = list.scrollLeft < 4;
      arrows[1].disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 4;
    }
    arrows.forEach(function (a) { a.addEventListener('click', function () { list.scrollBy({ left: +a.dataset.dir * list.clientWidth * 0.9, behavior: reduce ? 'auto' : 'smooth' }); }); });
    list.addEventListener('scroll', function () { window.requestAnimationFrame(upd); }, { passive: true });
    upd();
  }
  function init(root) { (root || document).querySelectorAll('[data-cgc-vr]').forEach(initSection); }
  window.CGCVideoReviews = { init: init, open: open, addToCart: addToCart, _player: player };
  init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
